import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { MetaReducer, StoreModule } from '@ngrx/store';
import { ChecklistStoreModule } from './checklist-store/checklist-store.module';
import { ChatStoreModule } from './chat-store';
import { ActionTypes } from './login-store/actions';
import { LoginStoreModule } from './login-store/login-store.module';
import { MyInformationStoreModule } from './my-information-store/my-information-store.module';
import { NotificationStoreModule } from './notification-store/notification-store.module';
import { PermissionStoreModule } from './permission-store/permission-store.module';
import { RelationshipStoreModule } from './relationship-store/relationship-store.module';
import { ReportStoreModule } from './report-store/report-store.module';
import { VaultStoreModule } from './vault-store/vault-store.module';
import { WorkspacesStoreModule } from './workspaces-store';
import { FamilyTreeStoreModule } from './family-tree-store/family-tree-store.module';

export function clearState(reducer) {
  return function (state, action) {
    if (action.type === ActionTypes.LOGOUT_SUCCESS) {
      state = undefined;
    }
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<any>[] = [clearState];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    LoginStoreModule,
    StoreModule.forRoot({}, { metaReducers }),
    EffectsModule.forRoot([]),
    VaultStoreModule,
    NotificationStoreModule,
    PermissionStoreModule,
    RelationshipStoreModule,
    ChecklistStoreModule,
    MyInformationStoreModule,
    ReportStoreModule,
    FamilyTreeStoreModule,
    WorkspacesStoreModule,
    ChatStoreModule,
  ],
})
export class RootStoreModule {}
